<mat-card class="widget">
    <div class="fab-buttons">
        <fab-no-title [icon]="'edit'" (click)="edit()"></fab-no-title>
    </div>
    <h1>{{'profile_settings.my_selected_location' | translate}}</h1>
    @if(userProfile$ | async; as profile) {
        @if (profile.location) {
            <div class="azure-map">
                <azure-map #mapelement>
                </azure-map>
            </div>
        } @else {
            <div class="empty-location">{{'profile_settings.empty_location' | translate}}</div>
        }
    }
</mat-card>